import React from 'react';

/**
 * Shared loading state for dashboard (desktop and mobile).
 */
export default function LoadingView({ mobile = false }) {
  const message = 'Loading positions...';
  if (mobile) {
    return (
      <div className="App mobile-app">
        <div className="mobile-content-wrapper">
          <div style={{ padding: '40px', textAlign: 'center', color: '#aaa' }}>
            {message}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="App">
      <header className="App-header">
        <h1>Funding Rate Monitor</h1>
        <p>{message}</p>
      </header>
    </div>
  );
}
